<template lang="pug">
    v-app
        notifications(group="app" position="bottom right")
        v-card(class="overflow-hidden")
            v-app-bar(
                dark
                fixed
                shrink-on-scroll
                src="https://images.unsplash.com/photo-1543996991-8e851c2dc841?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1502&q=80"
            )
                template(v-slot:img="{ props }")
                    v-img(
                        v-bind="props"
                        gradient="to top right, rgba(19,84,122,.5), rgba(128,208,199,.8)"
                    )

                v-app-bar-nav-icon(disabled)
                    v-icon mdi-heart
                

                v-toolbar-title Photon Web Service

                v-spacer

                v-menu(
                    :disabled="!isAuthenticated"
                    open-on-hover
                    offset-y
                )
                    template(v-slot:activator="{ on }")
                        v-btn(
                            icon
                            
                            v-on="on"
                            :disabled="!isAuthenticated"
                        )
                            v-icon mdi-information-outline
                    v-sheet
                        v-container
                            span(v-if="!userData") Данные отсутствуют
                            v-card(
                                class="mx-auto"
                                max-width="270"
                                outlined
                                v-else
                            )
                                v-list-item(two-line)
                                    v-list-item-content
                                        .overline.mb-4 Данные пользователя
                                        v-list-item-title.text.mb-1 Логин - {{userData.user && userData.user.loginName}}
                                        v-list-item-subtitle {{fullName}}

                v-btn(icon :disabled="!isAuthenticated || loading" @click="logout()")
                    v-icon mdi-logout
            v-sheet.content(
                class="overflow-y-auto"
                style="height: 100vh;"
            )
                router-view
</template>

<script>
import { mapGetters } from 'vuex';
import request from '@/utils/request';

export default {
    name: 'App',
    data: () => ({
        loading: false
    }),
    computed: {
        ...mapGetters(['isAuthenticated', 'userData']),
        fullName() {
            const notData = 'Данные отсутствуют';
            if (!this.userData || !this.userData.user) {
                return notData
            }

            const { firstName, lastName, middleName } = this.userData.user;
            return [lastName, firstName, middleName].filter(it => !!it).join(', ') || notData;
        }
    },
    created() {
        if (this.isAuthenticated && !this.userData) {
            this.getUserData();
        }
    },
    methods: {
        async logout() {
            if (this.loading) return;

            this.loading = true;

            await request({
                method: 'post', url: '/api/logout', data: {
                    login: this.login,
                    password: this.password,
                    server: this.server
                },
                withCredentials: true
            }).then(res => {
                if (res.status == 204) {
                    localStorage.removeItem('user-token')
                    this.$store.commit('AUTH_ERROR');

                    this.$notify({
                        group: 'app',
                        title: 'Sucess Logout',
                        text: `До скорой встречи`,
                        type: 'success'
                    });
                    this.$router.push('/login');
                }
            }).catch(err => {
                if (err.response && err.response.data && typeof err.response.data == 'string') {
                    this.$notify({
                        group: 'app',
                        title: 'Logout Error',
                        type: 'error',
                        text: err.response.data
                    });
                } else {
                    this.$notify({
                        group: 'app',
                        title: 'Logout Error',
                        type: 'error',
                        text: 'Неизвестная ошибка'
                    });
                }
            });

            setTimeout(() => {
                this.loading = false
            }, 1500)
        },

        getUserData() {
            request({
                method: 'get', url: '/api/user/data',
            }).then(res => {
                if (res.status == 200) {
                    this.$store.commit('SET_USER_DATA', res.data);
                }
            })
        }
    }
}
</script>

<style lang="scss">
    .v-sheet.content {
        padding-top: 128px;
    }
</style>
